import BlockType from '../../../../../enums/blockType';
import EdgeLabel from '../../../../../enums/edgeLabel';
import EdgeType from '../../../../../enums/edgeType';
import {
	Block as BlockV3,
	Edge as EdgeV3,
} from '../../../../../types/shared/blocksV3';
import { getOppositeEdge } from './edgeUtils';
import { v4 as uuidv4 } from 'uuid';

export function getDefaultBumpout(
	parentBlock: BlockV3 | null,
	selectedBlockEdge: EdgeV3 | undefined
) {
	if (!parentBlock || !selectedBlockEdge) return;

	const defaultWidth = 84;
	const defaultDepth = 24;

	const widthDimension =
		selectedBlockEdge.label == EdgeLabel.TOP ||
		selectedBlockEdge.label == EdgeLabel.BOTTOM
			? 'width'
			: 'height';

	const bumpoutId = uuidv4();

	const defaultBumpout: BlockV3 = {
		id: bumpoutId,
		type: BlockType.BUMPOUT,
		dimensions: {
			width: defaultWidth,
			depth: defaultDepth,
			height: parentBlock.dimensions.height,
		}, // Example dimensions
		displayDimensions: {
			width: widthDimension == 'width' ? defaultWidth : defaultDepth,
			height: widthDimension == 'width' ? defaultDepth : defaultWidth,
		},
		parentBlock: {
			id: parentBlock.id,
			type: parentBlock?.type,
			edgeId: selectedBlockEdge.id,
			segmentId: '',
		},
		edges: [
			EdgeLabel.TOP,
			EdgeLabel.RIGHT,
			EdgeLabel.BOTTOM,
			EdgeLabel.LEFT,
		].map((edge) => {
			const edgeId = uuidv4();

			const edgeLength =
				edge === selectedBlockEdge.label ||
				edge === getOppositeEdge(selectedBlockEdge.label)
					? defaultWidth
					: defaultDepth;

			const newEdge = {
				label: edge,
				id: edgeId,
				length: edgeLength,
				attachedToParent: edge == selectedBlockEdge.label,
				segments: [
					{
						id: uuidv4(),
						edgeId,
						blockId: bumpoutId,
						length: edgeLength,
						type:
							edge === selectedBlockEdge.label
								? EdgeType.HOUSE
								: EdgeType.DECKING,
					},
				],
			};

			return newEdge;
		}),
	};

	return defaultBumpout;
}

export default getDefaultBumpout;
